import ConfiguratorService from '@configuratorware/configurator-frontendgui/App/Services/ConfiguratorService';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';

export default class CustomConfiguratorService extends ConfiguratorService {
  constructor() {
    super();
  }

  initialize() {
    super.initialize();
  }

  addToCartCallback(configuration) {
    // after saving call parent function if existing or send postMessage (depending on the configuration)
    super.addToCartCallback(configuration);
    Services.ui.hide('globalLoader');
  }
}
